import script from "./OnboardingWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingWizard.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingWizard.vue?vue&type=style&index=0&id=aea3ed48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aea3ed48"]])

export default __exports__